/**
 * Safely access WebKit message handlers to prevent undefined errors
 * This is commonly needed for analytics scripts that expect WebView communication
 */
export function ensureWebKitMessageHandlers(): void {
  if (typeof window === 'undefined') {
    return;
  }

  // Ensure webkit object exists
  if (!window.webkit) {
    window.webkit = {};
  }

  // Ensure messageHandlers object exists
  if (!window.webkit.messageHandlers) {
    window.webkit.messageHandlers = {};
  }
}

/**
 * Safely post a message to a WebKit message handler
 * @param handlerName - The name of the message handler
 * @param message - The message to post
 */
export function safePostMessage(handlerName: string, message: any): void {
  ensureWebKitMessageHandlers();

  const handler = window.webkit?.messageHandlers?.[handlerName];
  if (handler && typeof handler.postMessage === 'function') {
    try {
      handler.postMessage(message);
    }
    catch (error) {
      // Silently fail if postMessage fails
      console.warn(`Failed to post message to ${handlerName}:`, error);
    }
  }
}
